<bit-dialog dialogSize="default" background="alt">
  <span bitDialogTitle>
    {{ titleKey | i18n }}
  </span>
  <ng-container bitDialogContent>
    <vault-cipher-form-generator
      [type]="params.type"
      [uri]="uri"
      (valueGenerated)="onValueGenerated($event)"
      (algorithmSelected)="onAlgorithmSelected($event)"
      disableMargin
    ></vault-cipher-form-generator>
  </ng-container>
  <ng-container bitDialogFooter>
    <button
      type="button"
      bitButton
      buttonType="primary"
      (click)="selectValue()"
      data-testid="select-button"
      [disabled]="!(buttonLabel() && generatedValue())"
    >
      {{ buttonLabel() }}
    </button>
  </ng-container>
</bit-dialog>
